import * as React from 'react';
import { connect } from 'react-redux';
import { IApplicationState } from '../../store/ApplicationState';
import { actionCreator, IActions } from '../../common/store/posts/actions/creators';
import { IState } from '../../common/store/posts/state';
import { StyledComponentProps, Grid, withStyles } from '@material-ui/core';
import ListPostSent from './components/ListPostSent';
import Search from './components/Filter/Filters';
import { Export } from './components/Export';
import { styles } from './styles';

interface IProps extends IActions, IState, StyledComponentProps { }

class CompContainer extends React.Component<Partial<IProps>>
{
    componentDidMount() {
        this.props && this.props.loadDelivered && this.props.loadDelivered();
    }

    render() {
        const { postsent, getContent } = this.props;
        return (
            <Grid container>
            <Grid item sm={12}>
                <Search loadDelivered={this.props.loadDelivered} />
            </Grid>
            <Grid item sm={12}>
                <ListPostSent
                    classes={this.props.classes}
                    postList={postsent}
                    getContent={getContent}
                    loadVotes={this.props.loadVotes}
                    loadStatsVote={this.props.loadStatsVote}
                />
                {this.props.posts && this.props.posts.length > 0 && <Export print={() => { window.print() }} download={() => { }} />}
            </Grid>
        </Grid>
        );
    }
}
const mapStateToProps = (state: IApplicationState, ownProps: Partial<IActions & IState>) => {
    return {
        ...ownProps,
        ...state.posts
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch)
    }
};

export const PostSent = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CompContainer));